import generatedGitInfo from '../../generatedGitInfo.json';

/**
 * Retreive git information, used to better mocking.
 * @returns
 */
export const RetreiveGitInfo = () => {
  return generatedGitInfo;
};
